import { render, staticRenderFns } from "./propaganda.vue?vue&type=template&id=ec1e1700&"
import script from "./propaganda.vue?vue&type=script&lang=js&"
export * from "./propaganda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec1e1700')) {
      api.createRecord('ec1e1700', component.options)
    } else {
      api.reload('ec1e1700', component.options)
    }
    module.hot.accept("./propaganda.vue?vue&type=template&id=ec1e1700&", function () {
      api.rerender('ec1e1700', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/robot/propaganda/propaganda.vue"
export default component.exports